import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'
import * as tkn from '../Snackbar/Snackbar.tokens'

export const Root = styled(Stack)(({ theme }) => ({
  position: 'fixed',
  zIndex: theme.zIndexes.snackbar,
  left: '50%',
  top: theme.spacing(2),
  gap: tkn.SnackbarSpacingMediumDesktopGap,
  alignItems: 'center',
  maxWidth: '600px',
  transform: 'translateX(-50%)',
}))
